// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"1228":"3d3ed636","2105":"e10d80ad"}[chunkId] + ".chunk.css");